import React, { useState } from 'react';

import { Box, TextField, Autocomplete } from '@mui/material';
import countries from '../../../../util/countries';

export default function DealCountryField({ value, error, setValue, setError }) {
  const [selected, setSelected] = useState(
    countries.find((country) => country.abbr === value)
  );

  const handleChange = (event, newValue) => {
    setSelected(newValue);
    if (newValue) {
      setValue(newValue.abbr);
      setError(false);
    } else {
      setError('Country cannot be blank');
    }
  };

  return (
    <Box>
      <Autocomplete
        id='country'
        aria-required
        options={countries}
        value={selected}
        onChange={handleChange}
        getOptionLabel={(option) => `${option ? option.name : ''}`}
        renderInput={(params) => (
          <TextField
            {...params}
            required
            error={Boolean(error || value === '')}
            label='Country'
          />
        )}
      />
    </Box>
  );
}
